<script>
	import { Router, Route } from "svelte-routing";
	
	import Account from "./routes/account/Account.svelte";
	import Account_Email from "./routes/account/Account_Email.svelte";
	import Account_Passwort from "./routes/account/Account_Passwort.svelte";
	import Account_Loeschen from "./routes/account/Account_Loeschen.svelte";
	
	import Password_Reset from "./routes/passwort/Password_Reset.svelte";
	import Password_ResetEmailSent from "./routes/passwort/Password_ResetEmailSent.svelte";

	import PrivacyPolicy from "./routes/PrivacyPolicy.svelte";
	import LegalNotice from "./routes/LegalNotice.svelte";
	
	import AuthActionHandler from "./routes/authActions/AuthActionHandler.svelte";
    import Stamp from "./routes/Stamp.svelte";
    import Stamps from "./routes/Stamps.svelte";
    import Profile from "./routes/Profile.svelte";
    import Verwalten from "./routes/verwalten/Verwalten.svelte";
    import Delete from "./routes/verwalten/Delete.svelte";
    import Devices from "./routes/Devices.svelte";
    import Lotteries from "./routes/lotteries/Lotteries.svelte";
    import Lottery from "./routes/lotteries/Lottery.svelte";
    import LotteryJoin from "./routes/lotteries/LotteryJoin.svelte";
    import Admin from "./routes/Admin.svelte";
    import Admin_Lotteries from "./routes/lotteries/Admin_Lotteries.svelte";
    import Admin_Lottery from "./routes/lotteries/Admin_Lottery.svelte";
    import CardsWrapper from "./routes/cards/CardsWrapper.svelte";

	import Navbar from "./components/navbar/Navbar.svelte";
	import Reroute from "./components/auth/Reroute.svelte";
    import AccessHandler from "./components/auth/AccessHandler.svelte";

    import SignUpHandler from "./routes/signup/SignUpHandler.svelte";
    import Invoices from "./routes/subscription/Invoices.svelte";
    import ChangeSubscription from "./routes/subscription/ChangeSubscription.svelte";
    import Customer from "./routes/subscription/Customer.svelte";
    import CustomerEdit from "./routes/subscription/CustomerEdit.svelte";
    import Checkout from "./routes/subscription/checkout_serverside/Checkout.svelte";
    import BuyButton from "./routes/subscription/checkout_serverside/BuyButton.svelte";
    import StatusSetup from "./routes/subscription/checkout_serverside/StatusSetup.svelte";
    import StatusPayment from "./routes/subscription/checkout_serverside/StatusPayment.svelte";
    import Test from "./routes/Test.svelte";
    import Offers from "./routes/Offers.svelte";
</script>

<Router>
	<Route path="/test">
		<Test />
	</Route>

	<Route path="/">
		<AccessHandler>
			<Profile slot="free"/>	
		</AccessHandler>
	</Route>
	<Route path="/profil">
		<AccessHandler>
			<Profile slot="free"/>
		</AccessHandler>
	</Route>
	
	<Route path="/stempel-legacy">
		<AccessHandler>
			<Stamp slot="free"/>
		</AccessHandler>
	</Route>

	<Route path="/stempel">
		<AccessHandler>
			<Stamps slot="free"/>
		</AccessHandler>
	</Route>

	<Route path="/stempelkarten/*">
		<AccessHandler>
			<CardsWrapper slot="free">
			</CardsWrapper>
		</AccessHandler>
	</Route>

	<!-- <Route path="/losaktionen">
		<AccessHandler>
			<Lotteries slot="free"/>
		</AccessHandler>
	</Route>
	<Route path="/losaktion/beitreten/:id" let:params>
		<AccessHandler>
			<LotteryJoin slot="free" inviteId={params.id}/>
		</AccessHandler>
	</Route>
	<Route path="/losaktion/:id" let:params>
		<AccessHandler>
			<Lottery slot="free" id={params.id}/>
		</AccessHandler>
	</Route> -->
	
	<Route path="/geraete">
		<AccessHandler>
			<Devices slot="free"/>
		</AccessHandler>
	</Route>

	<Route path="/angebote">
		<AccessHandler>
			<Offers slot="free"/>
		</AccessHandler>
	</Route>
	
	<!-- <Route path="/verwalten">
		<AccessHandler>
			<Verwalten slot="free"/>
		</AccessHandler>
	</Route>
	<Route path="/verwalten/loeschen">
		<AccessHandler>
			<Delete slot="free"/>
		</AccessHandler>
	</Route> -->

	<Route path="/datenschutz">
		<Navbar />
		<main>
			<PrivacyPolicy />
		</main>
	</Route>
	<Route path="/impressum">
		<Navbar />
		<main>
			<LegalNotice />
		</main>
	</Route>

	<Route path="/account">
		<AccessHandler>
			<main slot="free">
				<Account/>
			</main>
		</AccessHandler>
	</Route>
	<Route path="/account/email">
		<AccessHandler>
			<main slot="free">
				<Account_Email/>
			</main>
		</AccessHandler>
	</Route>
	<Route path="/account/passwort">
		<AccessHandler>
			<main slot="free">
				<Account_Passwort/>
			</main>
		</AccessHandler>
	</Route>
	<Route path="/account/loeschen">
		<AccessHandler>
			<main slot="free">
				<Account_Loeschen/>
			</main>
		</AccessHandler>
	</Route>
	
	<!-- <Route path="/subscriptions">
		<AccessHandler>
			<Customer slot="free"/>
		</AccessHandler>
	</Route>
	<Route path="/subscriptions/rechnungen">
		<AccessHandler>
			<Invoices slot="free"/>
		</AccessHandler>
	</Route>
	<Route path="/subscriptions/rechnungsdaten">
		<AccessHandler>
			<CustomerEdit slot="free"/>
		</AccessHandler>
	</Route>
	<Route path="/subscriptions/:id" let:params>
		<AccessHandler>
			<ChangeSubscription slot="free" subscription_id={params.id}/>
		</AccessHandler>
	</Route>

	<Route path="/checkout/:session_id" let:params>
		<AccessHandler>
			<Checkout session_id={params.session_id} slot="free"/>
		</AccessHandler>
	</Route>

	<Route path="/status/setup/:client_secret" let:params>
		<AccessHandler>
			<StatusSetup client_secret={params.client_secret} slot="free"/>
		</AccessHandler>
	</Route>
	<Route path="/status/payment/:client_secret" let:params>
		<AccessHandler>
			<StatusPayment client_secret={params.client_secret} slot="free"/>
		</AccessHandler>
	</Route> -->
	
	
	<Route path="/login">
		<AccessHandler>
			<Reroute slot="free"/> 
		</AccessHandler>
	</Route>

	<!-- Passwort vergessen -->
	<Route path="/passwort/reset">
		<main>
			<Password_Reset />
		</main>
	</Route>
	<Route path="/passwort/reset-email-versandt">
		<main>
			<Password_ResetEmailSent />
		</main>
	</Route>

	<Route path="/auth/*">
		<main>
			<AuthActionHandler/>
		</main>
	</Route>
</Router>

<style>
	main {
        max-width: 42rem;
        width: 100%;
        margin: auto;
    }
</style>